import { assert, memone } from '@deqo/foundation';
import { ReadStore } from '../../concepts/revive/ReadStore';

export type LibraryIndexer<T> = (t: T) => string;

export abstract class LibraryBase<T> extends ReadStore<Record<string, T>> implements Iterable<T> {

    protected state: Record<string, T> = {};

    protected abstract index(item: T): string;

    public has(key: string) {
        return !!this.state[key];
    }

    public get(key: string) {
        assert(!!this.state[key], `Library: no item registered with "${key}".`);
        return this.state[key];
    }

    public getMaybe(key: string) {
        return this.state[key] ?? null;
    }

    public getAll() {
        return this.getList(this.state);
    }

    public register(item: T) {
        const key = this.index(item);
        assert(!this.state[key], `Library: item already registered with "${key}".`);
        this.mutate(s => void (s[key] = item));
    }

    [Symbol.iterator](): Iterator<T> {
        return Object.values(this.state)[Symbol.iterator]();
    }

    @memone()
    private getList(state: Record<string, T>) {
        return Array.from(Object.values(state));
    }
}
